var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPasskeyIcon = function SvgPasskeyIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 20H6a1 1 0 0 1-1-1v-2a6.002 6.002 0 0 1 3.873-5.612 4 4 0 1 1 4.255 0c-.289.185-.665.389-1.128.612v-1.171a3 3 0 1 0-2 0V12.1A5.003 5.003 0 0 0 6 17v2h7v1ZM17.5 13.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 12a2 2 0 0 0-1.2 3.6l.2.15v4.107l.991.944.866-.865-1-1.5 1-1-.517-.775a.5.5 0 0 1 .265-.754A2.001 2.001 0 0 0 17 12Zm-3 2a3 3 0 1 1 4.5 2.599l.643.965-1 1 1 1.5-2.134 2.135L15 20.286v-4.05A2.993 2.993 0 0 1 14 14Z",
    fill: "#fff"
  })));
};
export default SvgPasskeyIcon;